// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"935eadd4","182":"935eadd4","495":"54beb4c2","518":"54beb4c2"}[chunkId] + ".chunk.css";
};